import { h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars

export default (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 119.6 119.6"
    width={props.width ?? 70}
    height={props.height ?? 70}
    class={props.class}
  >
    <path
      d="M113.84 85.43A59.82 59.82 0 0 0 59.8 0 59.8 59.8 0 0 0 0 59.8a59.62 59.62 0 0 0 5.76 25.63c9.6-8.08 30.19-13.67 54-13.67s44.48 5.59 54.08 13.67Z"
      style={{ fill: '#ececec' }}
    />
    <path
      d="M113.84 85.43c-9.6-8.08-30.18-13.67-54-13.67s-44.43 5.59-54 13.67a59.81 59.81 0 0 0 108.07 0Z"
      style={{ fill: '#cbcbcb' }}
    />
    <path
      d="M56.88 13.57h20.58a6.34 6.34 0 0 1 6.44 6.21v79.09a6.35 6.35 0 0 1-6.44 6.21H40.61a6.36 6.36 0 0 1-6.44-6.21V19.78a6.35 6.35 0 0 1 6.44-6.21Z"
      style={{ fill: '#c30f15' }}
    />
    <circle cx="59.04" cy="97.22" r="3.75" style={{ fill: '#fff' }} />
    <path
      d="M39.15 26.35h39.78v62.71H39.15zM64.17 21H53.9a.94.94 0 1 1 0-1.88h10.27a.94.94 0 0 1 0 1.88Z"
      style={{ fill: '#fff' }}
    />
    <path
      d="m47 60.86 3.41-3.41 6.25 6.25V45.52h4.55V63.7l6.25-6.25 3.41 3.41-11.98 11.93Z"
      style={{ fill: '#c30c15' }}
    />
  </svg>
);
